/**
 * @param {HTMLDivElement} element
 * @constructor
 */
const ScrollContainer = function(element) {
    if (!element) return; // Just in case, but should not be possible.

    /**
     * @type {HTMLDivElement}
     */
    const innerElement = element.querySelector('.category-list__inner');
    const prevButton = element.querySelector('.category-list__arrow-prev');
    const nextButton = element.querySelector('.category-list__arrow-next');

    if (!innerElement || !prevButton || !nextButton) {
        // throw new Error(""); // ?????
        return;
    }

    let resizeTimeout = 0;

    /**
     * Exectutes whatever actions needed on `scroll` event.
     * This function is currently NOT being throttled.
     */
    const onScroll = () => {
        determineArrowVisibility();
    }


    /**
     * Exectutes whatever actions needed on `resize` event.
     * This function is currently being throttled by `resizeEventHandler`.
     */
    const onResize = (e) => {
        determineArrowVisibility();
    }

    /**
     * Handle/manage what to do, when to do and how often etc.
     * @param {Event} e
     * @return {void}
     */
    const scrollEventHandler = (e) => {
        onScroll(e);
    }

    /**
     * Handle/manage what to do, when to do and how often etc.
     * This method will wait for resize to finish before executing `onResize`.
     * @param {Event} e
     * @return {void}
     */
    const resizeEventHandler = (e) => {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => onResize(e), 100);
    }

    /**
     * Caulculate current scroll positions, whether we're at the start or the end of the scrollable area.
     * Executes functions based on results
     * @return {void}
     */
    const determineArrowVisibility = () => {
        let hasScrollableContent = innerElement.scrollWidth > innerElement.offsetWidth;
        if (!hasScrollableContent) {
            hidePrevArrow();
            hideNextArrow();
            return;
        }

        let scrollAtStart = innerElement.scrollLeft === 0;
        let srollAtEnd = innerElement.scrollLeft + innerElement.offsetWidth >= innerElement.scrollWidth;

        scrollAtStart ? hidePrevArrow() : showPrevArrow();
        srollAtEnd ? hideNextArrow() : showNextArrow();
    }

    /**
     * Show the "previous" button
     * @return {void}
     */
    const showPrevArrow = () => element.classList.add('show-prev');

    /**
     * Show the "next" button
     * @return {void}
     */
    const showNextArrow = () => element.classList.add('show-next');

    /**
     * Hide the "previous" button
     * @return {void}
     */
    const hidePrevArrow = () => element.classList.remove('show-prev');

    /**
     * Hide the "next" button
     * @return {void}
     */
    const hideNextArrow = () => element.classList.remove('show-next');

    /**
     * Executes scroll left
     */
    const doScrollPrev = () => {
        let newPosition = innerElement.scrollLeft - 340;
        newPosition = newPosition < 0 ? 0 : newPosition;
        innerElement.scrollTo({ left: newPosition, behavior: 'smooth' });
    }

    /**
     * Executes scroll right
     */
    const doScrollNext = () => {
        let newPosition = innerElement.scrollLeft + 340;
        newPosition = newPosition > innerElement.scrollWidth ? innerElement.scrollWidth : newPosition;
        innerElement.scrollTo({ left: newPosition, behavior: 'smooth' });
    }

    /**
     * Pseudo constructor
     * @private
     */
    const __constructor = function () {
        innerElement.addEventListener('scroll', scrollEventHandler);
        prevButton.addEventListener('click', doScrollPrev);
        nextButton.addEventListener('click', doScrollNext);
        window.addEventListener('resize', resizeEventHandler);
        setTimeout(determineArrowVisibility, 1000);
    }

    __constructor();
}

const ScrollContainerInitializer = function() {
    const __constructor = function () {
        const elements = document.querySelectorAll('.js-category-list');
        if (!elements.length) return;

        elements.forEach(element => {
            if (!element) return; // Just in case, but should not be possible.
            new ScrollContainer(element);
        });
    }

    __constructor();
}

export default ScrollContainerInitializer;
